import { createErrorWrapper } from '../utils';

export const CREATE_ERROR = 'CUSTOMER.CREATE_ERROR';
export const UPDATE_ERROR = 'CUSTOMER.UPDATE_ERROR';
export const NOT_FOUND_ERROR = 'CUSTOMER.NOT_FOUND_ERROR';

export const creatingErr = createErrorWrapper(CREATE_ERROR, 'Не удалось создать гостя');
export const updatingErr = createErrorWrapper(UPDATE_ERROR, 'Не удалось сохранить гостя');
export const notFoundErr = createErrorWrapper(NOT_FOUND_ERROR, 'Не удалось найти гостя');
